/* =========================================================
   Frequently bought together
   Live total, variant pickers, recommendations and add to cart.
   Lightweight, no dependencies.
   ========================================================= */
(function () {
  'use strict';

  if (customElements.get('frequently-bought-together')) return;

  function formatMoney(cents, format) {
    var value = Number(cents) || 0;
    var template = format || '{{amount}}';

    function withDelimiters(number, decimals, thousands, decimal) {
      var fixed = (number / 100).toFixed(decimals);
      var parts = fixed.split('.');
      var whole = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousands);
      return decimals > 0 ? whole + decimal + parts[1] : whole;
    }

    return template.replace(/\{\{\s*(\w+)\s*\}\}/, function (match, key) {
      switch (key) {
        case 'amount_no_decimals':
          return withDelimiters(value, 0, ',', '.');
        case 'amount_with_comma_separator':
          return withDelimiters(value, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator':
          return withDelimiters(value, 0, '.', ',');
        case 'amount_with_apostrophe_separator':
          return withDelimiters(value, 2, "'", '.');
        case 'amount_with_space_separator':
          return withDelimiters(value, 2, ' ', ',');
        case 'amount_no_decimals_with_space_separator':
          return withDelimiters(value, 0, ' ', ',');
        default:
          return withDelimiters(value, 2, ',', '.');
      }
    });
  }

  class FrequentlyBoughtTogether extends HTMLElement {
    connectedCallback() {
      this.list = this.querySelector('[data-fbt-list]');
      this.media = this.querySelector('[data-fbt-media-list]');
      this.button = this.querySelector('[data-fbt-add]');
      this.label = this.querySelector('[data-fbt-label]');
      this.status = this.querySelector('[data-fbt-status]');
      this.format = this.dataset.moneyFormat || '{{amount}}';
      this.discount = parseFloat(this.dataset.discount) || 0;

      this.onChange = this.onChange.bind(this);
      this.onAdd = this.onAdd.bind(this);
      this.addEventListener('change', this.onChange);
      if (this.button) this.button.addEventListener('click', this.onAdd);

      this.update();
      if (this.dataset.url) this.loadRecommendations();
    }

    disconnectedCallback() {
      this.removeEventListener('change', this.onChange);
      if (this.button) this.button.removeEventListener('click', this.onAdd);
    }

    fetchRecs(url) {
      return fetch(url)
        .then(function (response) {
          return response.ok ? response.text() : '';
        })
        .then(function (text) {
          if (!text) return null;
          var doc = new DOMParser().parseFromString(text, 'text/html');
          var items = doc.querySelector('[data-fbt-rec-items]');
          var media = doc.querySelector('[data-fbt-rec-media]');
          if (!items || !items.querySelector('[data-fbt-item]')) return null;
          return { items: items, media: media };
        })
        .catch(function () {
          return null;
        });
    }

    loadRecommendations() {
      var self = this;
      var url = this.dataset.url;
      var fallback = this.dataset.intent === 'complementary' ? url.replace('intent=complementary', 'intent=related') : '';

      this.fetchRecs(url)
        .then(function (result) {
          return result || !fallback ? result : self.fetchRecs(fallback);
        })
        .then(function (result) {
          if (!result || !self.isConnected) return;

          Array.prototype.forEach.call(result.items.children, function (node) {
            node.setAttribute('data-fbt-rec', '');
            self.list.appendChild(document.importNode(node, true));
          });
          if (result.media && self.media) {
            Array.prototype.forEach.call(result.media.children, function (node) {
              node.setAttribute('data-fbt-rec', '');
              self.media.appendChild(document.importNode(node, true));
            });
          }

          self.classList.add('is-loaded');
          self.hidden = false;
          var wrapper = self.closest('[data-fbt-section]');
          if (wrapper) {
            wrapper.hidden = false;
            var hint = wrapper.querySelector('[data-fbt-hint]');
            if (hint) hint.remove();
          }
          self.update();
        });
    }

    items() {
      return Array.prototype.slice.call(this.querySelectorAll('[data-fbt-item]'));
    }

    onChange(event) {
      var target = event.target;
      var item = target.closest('[data-fbt-item]');
      if (!item) return;

      if (target.matches('[data-fbt-variant]')) {
        var option = target.options[target.selectedIndex];
        var check = item.querySelector('[data-fbt-check]');
        item.dataset.price = option.dataset.price;
        item.dataset.compare = option.dataset.compare;
        if (check) {
          check.value = option.value;
          check.disabled = option.disabled;
          if (option.disabled) check.checked = false;
        }

        var price = item.querySelector('[data-fbt-item-price]');
        var compare = item.querySelector('[data-fbt-item-compare]');
        if (price) price.textContent = formatMoney(option.dataset.price, this.format);
        if (compare) {
          compare.textContent =
            Number(option.dataset.compare) > Number(option.dataset.price) ? formatMoney(option.dataset.compare, this.format) : '';
        }
      }

      this.update();
    }

    update() {
      var self = this;
      var total = 0;
      var compareTotal = 0;
      var count = 0;

      this.items().forEach(function (item) {
        var check = item.querySelector('[data-fbt-check]');
        var on = !!(check && check.checked && !check.disabled);
        var id = item.dataset.productId;

        item.classList.toggle('is-off', !on);
        if (self.media) {
          var media = self.media.querySelector('[data-fbt-media="' + id + '"]');
          var plus = self.media.querySelector('[data-fbt-plus="' + id + '"]');
          if (media) media.classList.toggle('is-off', !on);
          if (plus) plus.classList.toggle('is-off', !on);
        }

        if (on) {
          count += 1;
          total += Number(item.dataset.price) || 0;
          compareTotal += Math.max(Number(item.dataset.compare) || 0, Number(item.dataset.price) || 0);
        }
      });

      var bundleOn = this.discount > 0 && count > 1;
      var finalTotal = bundleOn ? Math.round((total * (100 - this.discount)) / 100) : total;
      var saved = compareTotal - finalTotal;

      var totalEl = this.querySelector('[data-fbt-total]');
      var compareEl = this.querySelector('[data-fbt-total-compare]');
      var saveEl = this.querySelector('[data-fbt-save]');

      if (totalEl) totalEl.textContent = formatMoney(finalTotal, this.format);
      if (compareEl) compareEl.textContent = saved > 0 ? formatMoney(compareTotal, this.format) : '';

      if (saveEl) {
        var template = this.dataset.saveTemplate || '';
        if (template && saved > 0 && count > 0) {
          var percent = compareTotal > 0 ? Math.round((saved / compareTotal) * 100) : 0;
          saveEl.textContent = template.replace('[amount]', formatMoney(saved, this.format)).replace('[percent]', percent);
          saveEl.hidden = false;
        } else {
          saveEl.hidden = true;
        }
      }

      if (this.label && !this.button.classList.contains('is-loading')) {
        this.label.textContent = (this.label.dataset.template || '').replace('[count]', count);
      }
      if (this.button && !this.button.classList.contains('is-loading')) this.button.disabled = count === 0;
    }

    onAdd(event) {
      event.preventDefault();
      var self = this;
      var shain = window.ShainPro || {};
      var routes = shain.routes || {};

      var items = this.items()
        .map(function (item) {
          var check = item.querySelector('[data-fbt-check]');
          return check && check.checked && !check.disabled ? { id: parseInt(check.value, 10), quantity: 1 } : null;
        })
        .filter(Boolean);

      if (!items.length) return;

      if (this.status) this.status.textContent = '';
      this.button.classList.add('is-loading');
      this.button.disabled = true;
      if (this.label) this.label.textContent = this.dataset.adding || this.label.textContent;

      fetch((routes.cartAdd || '/cart/add') + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: items })
      })
        .then(function (response) {
          return response.json().then(function (data) {
            if (!response.ok) throw data;
            return data;
          });
        })
        .then(function () {
          if (self.label && self.dataset.added) self.label.textContent = self.dataset.added;
          document.dispatchEvent(new CustomEvent('fbt:added', { detail: { items: items } }));
          if (window.ShainProCart && typeof window.ShainProCart.refresh === 'function') {
            return window.ShainProCart.refresh();
          }
          return null;
        })
        .then(function () {
          if (self.dataset.openDrawer === 'true' && shain.Drawers) {
            var drawer = document.getElementById('CartDrawer');
            if (drawer) shain.Drawers.open(drawer);
          }
        })
        .catch(function (error) {
          if (self.status) self.status.textContent = (error && error.description) || self.dataset.error || 'Something went wrong.';
        })
        .then(function () {
          setTimeout(function () {
            self.button.classList.remove('is-loading');
            self.update();
          }, 900);
        });
    }
  }

  if (!window.customElements.get('frequently-bought-together')) {
    window.customElements.define('frequently-bought-together', FrequentlyBoughtTogether);
  }
})();